import { ReactNode } from 'react';

import { Button } from '@breezeventures/ui-kit/button';

export type FooterProps = {
  isLoading?: boolean;
  onSkip?: () => void;
  extraContent?: ReactNode;
  topContent?: ReactNode;
  submitButtonText: string;
  onSubmit?: () => void;
};

export const Footer = ({
  isLoading,
  onSkip,
  topContent,
  extraContent,
  submitButtonText,
  onSubmit,
}: FooterProps) => {
  return (
    <div className="flex w-full flex-col items-center gap-3 pt-3 pb-6">
      {topContent}
      <div className="w-full max-w-lg px-4">
        <div className="flex w-full gap-2">
          {onSkip && (
            <Button
              type="submit"
              size="l"
              variant="ghost"
              width="full"
              loading={isLoading}
            >
              Skip
            </Button>
          )}
          <Button
            type={onSubmit ? 'button' : 'submit'}
            size="l"
            variant="primary"
            width="full"
            loading={isLoading}
            onClick={onSubmit}
          >
            {submitButtonText}
          </Button>
        </div>
        {extraContent}
      </div>
    </div>
  );
};
